/**
 * SEY Danışmanlık Özel JavaScript Fonksiyonları
 * HTML'den Shopify'a dönüştürülmüş scriptler
 */

// Scroll Up Button
(function() {
  const scrollUpButton = document.getElementById('scrollUp');
  
  if (scrollUpButton) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        scrollUpButton.classList.add('show');
      } else {
        scrollUpButton.classList.remove('show');
      }
    });
    
    scrollUpButton.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
})();

// Accordion Functionality
(function() {
  const accordionHeaders = document.querySelectorAll('.sey-accordion-header');
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.closest('.sey-accordion-item');
      const content = item.querySelector('.sey-accordion-content');
      const isActive = this.classList.contains('active');
      
      // Close all accordions
      document.querySelectorAll('.sey-accordion-header').forEach(h => {
        h.classList.remove('active');
        h.closest('.sey-accordion-item').querySelector('.sey-accordion-content').classList.remove('active');
      });
      
      // Open clicked accordion if it wasn't active
      if (!isActive) {
        this.classList.add('active');
        content.classList.add('active');
      }
    });
  });
})();

// Smooth Scroll for Anchor Links
(function() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href.length > 1) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
})();

// Lazy Loading for Images
(function() {
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        }
      });
    });
    
    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }
})();

// Mobile Menu Toggle
(function() {
  const mobileMenuButton = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  
  if (mobileMenuButton && mobileMenu) {
    mobileMenuButton.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });
  }
})();

// WhatsApp Button Click Handler
(function() {
  const whatsappButtons = document.querySelectorAll('.ht-ctc-chat, .whatsapp-button');
  const whatsappNumber = '905066802301';
  const whatsappMessage = 'Merhaba, SEY Danışmanlık hakkında bilgi almak istiyorum.';
  
  whatsappButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
      window.open(url, '_blank');
    });
  });
})();

// Form Validation
(function() {
  const forms = document.querySelectorAll('form[data-validate]');
  
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const requiredFields = form.querySelectorAll('[required]');
      let isValid = true;
      
      requiredFields.forEach(field => {
        if (!field.value.trim()) {
          isValid = false;
          field.classList.add('error');
        } else {
          field.classList.remove('error');
        }
      });
      
      if (!isValid) {
        e.preventDefault();
        alert('Lütfen tüm zorunlu alanları doldurun.');
      }
    });
  });
})();

// Animation on Scroll
(function() {
  if ('IntersectionObserver' in window) {
    const animationObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          animationObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });
    
    document.querySelectorAll('.animate-me, .fade-in-up').forEach(el => {
      animationObserver.observe(el);
    });
  }
})();

console.log('SEY Danışmanlık custom scripts loaded');

